import React from 'react'
import Page from '../Page'
import MasterHeader from '../../Components/MasterHeader/MasterHeader'
import definition from './definition.json'
import ReCAPTCHA from "react-google-recaptcha";
import './Guestbook.css'

const Input = (props) => {

    const styleRight = {
        textAlign: 'right'
    }

    const styleLeft = {
        textAlign: 'left',
        paddingBottom: '5px'
    }

    return (
        <div className="row" style={{ paddingBottom: '10px' }}>
            <div className="col-md-6" style={styleRight}>{props.label}</div>
            <div className="col-md-6" style={styleLeft}>
                {props.children}
            </div>
        </div>
    )
}

class Guestbook extends Page {

    recaptchaRef = React.createRef();

    componentDidMount() {
        this.initialize();
    }

    componentWillUpdate() {
        if (this.props.send === 'OK') {
            this.setState({
                sendState: 'Messaggio inviato correttamente',
                sendStateIcon: 'fas fa-check-circle'
            })
        }
    }

    submit = (e) => {
        e.preventDefault();
        if (this.recaptchaRef.current.getValue().length === 0) return;

        this.setState({
            sendState: "Invio in corso....."
        })

        if (this.props.guest.name && this.props.guest.email && this.props.guest.content) {
            this.props.onSubmitMessage();
        }
    }

    sendState = () => {
        if (this.props.send === 'OK') {
            return (
                <span>
                    <i className="fas fa-check-circle" style={{ paddingRight: '20px' }}>
                    </i>Messaggio inviato correttamente
                </span>
            )
        }
        else {
            return (
                <span>Prego riempire tutti i campi</span>
            )
        }
    }


    render() {
        return (
            <div>
                <MasterHeader master={definition.master}>
                </MasterHeader>
                <form onSubmit={e => this.submit(e)}>
                    <section className="page-section guest_book_form">
                        <div className="container guest_book_form_section">
                            <Input>
                                <p className="guest_book_form_p">
                                    {this.sendState()}
                                </p>
                            </Input>
                            <Input label="Nome e Cognome">
                                <input className="form-control" defaultValue={this.props.guest.name}
                                    onChange={(e) => this.props.onUpdateField("name", e.target.value)} id="name" type="text" placeholder="Nome e Cognome" />
                            </Input>
                            <Input label="Email">
                                <input className="form-control" defaultValue={this.props.guest.email}
                                    onChange={(e) => this.props.onUpdateField("email", e.target.value)} id="mail" type="text" placeholder="mail@mail.com" />
                            </Input>
                            <Input label="Messaggio">
                                <textarea className="form-control"
                                    onChange={(e) => this.props.onUpdateField("content", e.target.value)}
                                    id="message" style={{ minHeight: '100px' }} value={this.props.guest.content}>
                                </textarea>
                            </Input>
                            <Input>
                                <button className="btn btn-primary" style={{ background: "#ddd", color: "#222" }} type="submit">
                                    <i className="fas fa-paper-plane" style={{ paddingRight: '20px' }}></i><span>Invia</span>
                                </button>
                            </Input>
                            <Input>
                                <ReCAPTCHA
                                    ref={this.recaptchaRef}
                                    sitekey="6Lfhfd8UAAAAAIhNo9a2S883jZhQPj7R0Px-jq3o"
                                />
                            </Input>
                        </div>
                    </section>
                </form >
            </div >
        );
    }
}

export default Guestbook;